import { styled } from '@mui/system'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import { Colors } from 'constants/colors'
import DescriptionIcon from '@mui/icons-material/Description'
import FavoriteIcon from '@mui/icons-material/Favorite'
import CachedIcon from '@mui/icons-material/Cached'
import ChatIcon from '@mui/icons-material/Chat'

const BootstrapDialog = styled(Dialog)(() => ({
  '& .MuiDialog-container': {
    '& .MuiPaper-root': {
      width: '100%',
      borderRadius: '15px',
      minWidth: '70vw',
      backgroundColor: Colors.backgroundDark,
      color: Colors.white,
    },
  },
}))

const ModalTitleStyle = styled(DialogTitle)({
  color: Colors.white,
  fontWeight: 700,
  fontSize: '18px',
})

const ModalContentStyle = styled(DialogContent)({})

const ModalContentHeader = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  width: '100%',
  margin: 0,
  padding: 0,
})

const ModalContentBody = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  flexDirection: 'column',
})

const CampaignName = styled('p')({
  fontSize: '24px',
  fontWeight: 700,
  color: Colors.white,
  margin: '0 0 10px 0',
  padding: 0,
})

const TitleWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  margin: 0,
  padding: 0,
})

const SectionTitle = styled('p')({
  color: Colors.white,
  fontSize: '17px',
  fontWeight: 'bold',
  margin: '15px 0',
  padding: 0,
})

const HitDetailWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'flex-start',
})

const HitKeywordWrapper = styled('div')({
  margin: '10px 0 0 0',
})
const HitUserDetail = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
})

const AvatarImage = styled('img')({
  width: '32px',
  height: '32px',
  marginRight: '5px',
  borderRadius: '30px',
})

const FavoriteIconStyle = styled(FavoriteIcon)({
  margin: '0 0 0 10px',
  padding: 0,
  fontSize: '20px',
  color: Colors.red,
})
const ShareIconStyle = styled(CachedIcon)({
  margin: '0 0 0 10px',
  padding: 0,
  fontSize: '20px',
  color: Colors.blue,
})

const DescriptionIconStyle = styled(DescriptionIcon)({
  margin: '0 8px 0 0',
  padding: 0,
  fontSize: '17px',
})
const ChatIconStyle = styled(ChatIcon)({
  margin: '0 8px 0 0',
  padding: 0,
  fontSize: '17px',
})

const Text = styled('p')({
  color: Colors.darkDeepGray,
  fontSize: '14px',
  fontWeight: 400,
  margin: 0,
  padding: 0,
  width: '100%',
  wordWrap: 'break-word',
})

const ThumbnailStyle = styled('img')({
  width: '30%',
  objectFit: 'cover',
  margin: '13px 0',
  borderRadius: '15px',
})
const ModalContentFooter = styled('div')({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  marginTop: '10px',
})

const ReactionWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  width: '100%',
  margin: 0,
  padding: 0,
})

const ReactionCounter = styled('p')({
  fontSize: '16px',
  color: Colors.darkDeepGray,
  margin: '0 0 0 5px',
  padding: 0,
})

const KeywordsWrapper = styled('div')({})

const TextArea = styled('textarea')({
  width: '100%',
  minHeight: '200px',
  borderRadius: '10px',
  border: '1px solid lightgray',
  background: Colors.backgroundDarkGray,
  padding: '15px',
  resize: 'none',
  color: Colors.white,
})

const HitModalStyle = {
  BootstrapDialog,
  ModalTitleStyle,
  ModalContentStyle,
  ModalContentHeader,
  CampaignName,
  HitDetailWrapper,
  HitUserDetail,
  Text,
  AvatarImage,
  ModalContentBody,
  TitleWrapper,
  SectionTitle,
  DescriptionIconStyle,
  ThumbnailStyle,
  ReactionWrapper,
  ReactionCounter,
  FavoriteIconStyle,
  ShareIconStyle,
  ModalContentFooter,
  KeywordsWrapper,
  HitKeywordWrapper,
  ChatIconStyle,
  TextArea,
}

export default HitModalStyle
